// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { TimeBaseEntity } from '../time-base-entity';
import { Bill } from './bill';
import { TimeEntryImport } from './time-entry-import';
import { TimeEntryImportBillDetail } from './time-entry-import-bill-detail';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class TimeEntryImportBill extends TimeBaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  billId?: number;
  billNote?: string;
  createdAt!: Date;
  createdBy?: string;
  invoiceDate!: Date;
  jobId!: number;
  jobTypeId!: number;
  reference?: string;
  timeEntryImportId!: number;
  ts?: any;
  updatedAt!: Date;
  updatedBy?: string;
  bill!: Bill;
  timeEntryImport!: TimeEntryImport;
  timeEntryImportBillDetails!: TimeEntryImportBillDetail[];
}

